/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-02-26 11:32:40
 **/

export default class MediaStreamUtility {
	static #instance: MediaStreamUtility;
	public static get instance() {
		if (!MediaStreamUtility.#instance) {
			MediaStreamUtility.#instance = new MediaStreamUtility();
		}
		return MediaStreamUtility.#instance;
	}

	public track_clone(tracks: MediaStreamTrack[]): MediaStreamTrack[] {
		if (tracks.length) {
			return tracks.reduce<MediaStreamTrack[]>((total, current) => {
				total.push(current.clone());
				return total;
			}, []);
		}
		return [];
	}
}
